import { useState, useContext } from 'react'
import Pagination from "../../../shared/Pagination";
import {
  IconButton, Skeleton
} from '@mui/material'
import {
  AddOutlined as AddOutlinedIcon,
  EditOutlined as EditIcon
} from '@mui/icons-material'
import { useForm } from "react-hook-form";
import { Button } from "../../../form-controls";
import UserForm from "./UserForm";
import { useQuery } from "react-query"
import { FetchContext } from "../../../../context/FetchContext"
import apiResources from '../../../../api/api.constants'

const Users = () => {
  const [page, setPage] = useState(1)
  const [open, setOpen] = useState(false);
  const [initialData, setInitialData] = useState({});
  const {
    register,
    handleSubmit,
  } = useForm()

  const onSubmitFilter = (data: any) => console.log(data)

  const handleClickOpen = (item: any) => {
    setOpen(true)
    setInitialData(item)
  }

  const handleClose = (status = null) => {
    setOpen(false)
    if(status === 'updated') {
      list.refetch()
    }
  }

  const { authFetch }: any = useContext(FetchContext)

  const getList = async (page: number = 1) => {
    const options = {
      filter: {
        "role": "admin"
      },
      range: {
        "page": page,
        "pageSize": 10
      }
    }

    const { data: response } = await authFetch.post(apiResources.getUsers, options)
    return response
  }

  const list = useQuery(['users', page], () => getList(page))

  return (
    <section className="listing-container mt-3">
      <form onSubmit={handleSubmit(onSubmitFilter)} autoComplete="off">
        <div className="listing-actions">
          <input className="form-control" {...register('searchSchool')} placeholder="Search for a user..." />
          <Button type='submit' className='ms-2'>Submit</Button>
          <Button onClick={handleClickOpen} className='ms-2' color='success' >
            <AddOutlinedIcon />
          </Button>
        </div>
      </form>

      <div className="table-responsive">
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col">Sno.</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Mobile</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {list.isLoading ? (
              <tr>
                <td><Skeleton variant='text' /></td>
                <td><Skeleton variant='text' /></td>
                <td><Skeleton variant='text' /></td>
                <td><Skeleton variant='text' /></td>
                <td className='d-flex'>
                  <Skeleton variant='circular' width={24} height={24} />
                </td>
              </tr>
            ) : list.data?.data?.length ? (
              list.data?.data?.map((item: any, i: number) => (
                <tr key={item.id}>
                  <td>{i + 1}</td>
                  <td>{item.firstName} {item.lastName}</td>
                  <td>{item.email}</td>
                  <td>{item.phone}</td>
                  <td>
                    <IconButton title='Edit' size="small" onClick={() => handleClickOpen(item)}>
                      <EditIcon fontSize='small' />
                    </IconButton>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5}>No Records Found...</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pagination totalPages={list.data?.pageCount} onChange={setPage} />
      {open && <UserForm open={open} handleClose={handleClose} initialData={initialData} />}
    </section>
  )
};

export default Users;
